import { isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { getStoredAuthToken } from '@core/auth/auth-token.storage';

import { LOGIN_INTENT_GUEST_UPGRADE } from '../../dashboard/api/payment-api.service';
import { UserSettingsService } from '../../dashboard/api/user-settings.service';

/**
 * Guests cannot use the real dashboard or onboarding until they sign in
 * and complete the full profile flow.
 */
export const guestPlatformBlockedGuard: CanActivateFn = (_route, state) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }
  if (!getStoredAuthToken()) {
    return true;
  }

  const router = inject(Router);
  const settings = inject(UserSettingsService);

  return settings.getSettings().pipe(
    map((data) => {
      if (!data.account.isGuest) {
        return true;
      }
      return router.createUrlTree(['/login'], {
        queryParams: {
          intent: LOGIN_INTENT_GUEST_UPGRADE,
          next: state.url.startsWith('/onboarding') ? '/onboarding/1' : '/dashboard',
        },
      });
    }),
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        return of(true);
      }
      return of(true);
    }),
  );
};
